import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=09d9e611&scoped=true"
import script from "./Activate.vue?vue&type=script&lang=ts"
export * from "./Activate.vue?vue&type=script&lang=ts"
import style0 from "./Activate.vue?vue&type=style&index=0&id=09d9e611&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d9e611",
  null
  
)

export default component.exports